import { useState } from "react";
import { CaretDown, CaretRight } from "@phosphor-icons/react";
import useAdminLoad from "@/hooks/useAdminLoad";
import { Empty, LoadState, Panel } from "@/components/admin/AdminUI";
import JsonDiff from "@/components/admin/JsonDiff";
import { formatDate } from "@/lib/format";

function Item({ a }) {
  const [open, setOpen] = useState(false);
  return (
    <li className="py-3" data-testid={`region-history-row-${a.id}`}>
      <button onClick={() => setOpen((o) => !o)} aria-expanded={open} className="flex w-full items-center gap-3 rounded text-left text-sm" data-testid={`region-history-toggle-${a.id}`}>
        {open ? <CaretDown size={14} /> : <CaretRight size={14} />}
        <span className="font-mono text-xs">{a.action}</span>
        <span className="cw-soft min-w-0 flex-1 truncate">{a.after?.label || a.before?.label || a.target_id}</span>
        <span className="cw-muted text-xs">{a.admin_email} · {formatDate(a.timestamp)}</span>
      </button>
      {open && <div className="mt-3 pl-7"><JsonDiff before={a.before} after={a.after} /></div>}
    </li>
  );
}

export default function RegionHistory({ refreshKey }) {
  const { data, error, loading, reload } = useAdminLoad(`/admin/regions/history?limit=100&_r=${refreshKey}`);
  return (
    <Panel className="p-6" data-testid="region-history">
      <h2 className="font-semibold">Change history</h2>
      <p className="cw-soft mt-1 text-sm">Every region change, who made it, and what changed.</p>
      <LoadState loading={loading && !data} error={error} onRetry={reload}>
        {data?.items?.length ? <ul className="mt-2 max-h-[420px] divide-y divide-border overflow-y-auto pr-1">{data.items.map((a, i) => <Item key={a.id || i} a={{ ...a, id: a.id || String(i) }} />)}</ul>
          : <Empty title="No changes yet" testId="region-history-empty" />}
      </LoadState>
    </Panel>
  );
}
